export default "<img *ngIf=\"status=='started'\" src=\"data:image/jpeg;base64,{{this.livestream}}\"/>\n"